export default {
  cavernous: "#515151",
  forestFern: "#5DBE66",
  grey: "#808080",
  thimbleberry: "#E64F4F",
  white: "#FFFFFF",
  red: "#B80F0A"
};
